import React from 'react';

import PopupFooter from './PopupFooter';
import tag from './Analytics';


function Twitter(props) {

  tag('twitter');

  return (
    <div className="gp-popup gp-popup-twitter">
      <div className="gp-close-icon" onClick={props.onClose}>
        <span className="icon">
          <i className="fa fa-window-close"></i>
        </span>
      </div>
      <div className="gp-content gp-no-counter">
        <h1 className="title">
          <span className="gp-subtitle-1">Je dis non au nucléaire sur Twitter</span>
        </h1>
        <div className="content">

          <p>
          Pour afficher votre opposition au nucléaire et soutenir les activistes de Greenpeace sur Twitter&nbsp;:
            <ol>
              <li>
                <b>Connectez-vous</b> sur votre compte Twitter
              </li>
              <li>
                Vérifiez que la <b>géolocalisation</b> est bien activée.<br/>
                Rendez-vous dans <i>Paramètres et confidentialité > Confidentialité et sécurité > Localisation > Localisation exacte</i>
              </li>
              <li>
                Tweetez avec le hashtag <b><a target="_blank" href="https://twitter.com/hashtag/40ansCaSuffit" rel="noopener noreferrer">#40ansCaSuffit</a></b>
              </li>
            </ol>
          </p>
          <div className="gp-column-welcome-twitter">
            <a
              target="_blank"
              className="button fa-twitter gp-button-welcome-form is-fullwidth is-medium "
              href="https://twitter.com/intent/tweet?text=%2340ansCaSuffit%20il%20est%20temps%20de%20d%C3%A9brancher%20les%20centrales%20!%20On%20a%20toutes%20et%20tous%20une%20raison%20l%C3%A9gitime%20de%20dire%20non%20au%20nucl%C3%A9aire.%20Je%20soutiens%20celles%20et%20ceux%20qui%20sont%20poursuivi%C2%B7es%20pour%20avoir%20lanc%C3%A9%20l%E2%80%99alerte%20%C3%A0%20Tricastin%20et%20ailleurs%20www.greenpeace.fr%2Fcarte-opposition-nucleaire"
              rel="noopener noreferrer"
            >
              <span>Je tweete</span>

              <span className="icon">
                <i className="fas fa-arrow-right"></i>
              </span>
            </a>
          </div>

          <div className="twitter-warning">
          Votre tweet apparaîtra dans quelques minutes sur la carte. Si ce n’est pas le cas, vérifiez que vous avez bien utilisé le hashtag #ProcèsDuNucléaire et la géolocalisation.
          </div>

        </div>
        <PopupFooter/>
      </div>
    </div>
  )
}

export default Twitter;
